import { render, staticRenderFns } from "./Whatsup.vue?vue&type=template&id=079f0c2d&"
import script from "./Whatsup.vue?vue&type=script&lang=ts&"
export * from "./Whatsup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports